import { render, staticRenderFns } from "./ZozoSales.vue?vue&type=template&id=0d81ba59&scoped=true&"
import script from "./ZozoSales.vue?vue&type=script&lang=js&"
export * from "./ZozoSales.vue?vue&type=script&lang=js&"
import style0 from "./ZozoSales.vue?vue&type=style&index=0&id=0d81ba59&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81ba59",
  null
  
)

export default component.exports